<template>
  <div id="copyright">
    <p>By using this service, you agree to abide by CSUB policies, data restrictions, and applicable laws.<br />
    &copy; {{ new Date().getFullYear() }} Copyright - California State University Bakersfield</p>
  </div>
</template>

<script>
export default {
  name: 'copyright',
  data () {
    return { }
  }
}
</script>

<style scoped>
  #copyright {
    font-family: "Open Sans";
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    margin-top: 60px;
    text-align: center;
    font-size: small;
    color: white;
    background: #003595; /* fallback for old browsers */
    /*background: -webkit-linear-gradient(to left, #003595, #0b6dac);*/ /* Chrome 10-25, Safari 5.1-6 */
    /*background: linear-gradient(to left, #003595, #0b6dac);*/ /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    opacity: 0.95;
    z-index: 99;
  }

  #copyright p {
    padding: 8px;
    z-index: 99;
  }
</style>
